import postCreditView from './postCreditComponent.html';
import './postCreditComponent.css';

export function postCreditComponent() {
	return {
		bindings: {
			post: '<',
			emailOnClick: '<?',
			avatarSize: '@',
		},
		controllerAs: 'vm',
		controller: postCreditComponentCtrl,
		template: postCreditView,
	};
}

export class postCreditComponentCtrl {
	constructor($window) {
		'ngInject';
		this.$window = $window;
	}

	$onInit() {
		this.avatarSize = this.avatarSize || '40';
	}

	sendMail() {
		if (!this.shouldSendEmail()) {
			return null;
		}

		let body = encodeURIComponent(this.$window.BASE_URL + '/p/' + this.post.id);
		let subject = encodeURIComponent(this.post.headline);
		this.$window.open(`mailto:${this.post.published_by.email}?subject=${subject}&body=${body}`, '_blank');
	}

	shouldSendEmail() {
		if (this.emailOnClick && this.hasPublisherEmail()) {
			return true;
		}
		return false;
	}

	hasPublisherEmail() {
		let email = false;
		try {
			email = this.post.published_by.email;
		} catch (e) {
			email = false;
		}
		return email !== false;
	}
}
